export const SAMPLE_DOGS = [
    { name: "Biscuit", breed: "Golden Retriever", distanceMiles: 12 },
    { name: "Maple", breed: "Cavalier King Charles Spaniel", distanceMiles: 8 },
    { name: "Otis", breed: "Bernedoodle", distanceMiles: 24 },
    { name: "Juniper", breed: "Australian Shepherd", distanceMiles: 5 },
    { name: "Pepper", breed: "Labrador Retriever", distanceMiles: 31 },
    { name: "Waffles", breed: "Corgi", distanceMiles: 17 },
    { name: "Luna", breed: "German Shepherd Dog", distanceMiles: 9 },
    { name: "Teddy", breed: "Goldendoodle", distanceMiles: 42 },
    { name: "Hazel", breed: "Beagle", distanceMiles: 14 },
    { name: "Mochi", breed: "Shiba Inu", distanceMiles: 27 },
    { name: "Rocco", breed: "Boxer", distanceMiles: 6 },
] as const;
